<div class="row">
  <fieldset style="border: 0" [disabled]="disableEdit()">
    <form class="row form-horizontal" #Crew="ngForm">
      <div class="col-md-5 col-xs-12 col-sm-12">
        <!--crew basic info-->
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Crew Information</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row">
              <div class="col-auto">
                <app-material-image-viewer
                  [documentId]="crew?.photoDocumentId ?? ''"
                  [alt]="crew?.firstName"
                  class="round-photo img-fluid"
                  >
                </app-material-image-viewer>
              </div>

              <div class="col">
                <div class="form-group row">
                  <app-material-pg-input
                    type="text"
                    name="firstname"
                    id="firstname"
                    [(ngModel)]="crew.firstName"
                    label="First Name"
                    tabindex="1"
                    [required]= "true"
                  >
                  </app-material-pg-input>
                </div>

                <div class="form-group row">
                  <app-material-pg-input
                    type="text"
                    name="lastname"
                    id="lastname"
                    [(ngModel)]="crew.lastName"
                    label="Last Name"
                    tabindex="2"
                    [required]= "true"
                  >
                  </app-material-pg-input>
                </div>

                <div class="form-group row">
                  <app-material-pg-input
                    type="text"
                    name="middleName"
                    id="middleName"
                    [(ngModel)]="crew.middleName"
                    label="Middle Name"
                    tabindex="3"
                  >
                  </app-material-pg-input>
                </div>

                <div class="form-group row">
                  <app-material-pg-input
                    type="date"
                    name="birthDate"
                    id="birthDate"
                    [(ngModel)]="crew.birthDate"
                    label="Birth Date"
                    tabindex="4"
                    [required]= "true"
                  >
                  </app-material-pg-input>
                </div>

                <div class="form-group row">
                  <app-material-pg-input
                    type="text"
                    name="contactNumber"
                    id="contactNumber"
                    [(ngModel)]="crew.contactNumber"
                    label="Contact Number"
                    tabindex="7"
                  >
                  </app-material-pg-input>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <app-material-pg-input
                  type="text"
                  name="userName"
                  id="userName"
                  [(ngModel)]="crew.ssoUsername"
                  label="SSO Username"
                  tabindex="5"
                >
                </app-material-pg-input>
              </div>

              <div class="col-6 ps-0">
                <app-material-organisation-selector
                  id="nationality"
                  [(ngModel)]="nationality"
                  [organisationLanguage]="'en'"
                  name="nationality"
                  [organisations]="nationalityItem"
                  [disabled]="disableEdit()"
                  [placeholder]="'Nationality'"
                  tabindex="6"
                  [required]= "true"
                  >
                </app-material-organisation-selector>
              </div>

            </div>
            <div class="form-group row">
              <app-material-chunk-file-uploader
                class="col-6"
                label="Photo"
                [accept]="'.img,.jpg'"
                id="photo"
                name="photo"
                [(ngModel)]="crew.photoDocumentId"
                (ngModelChange)="photoUploaded($event)"
                [required]= "!crew.photoDocumentId"
                tabindex="8"
                >
              </app-material-chunk-file-uploader>

              <app-material-chunk-file-uploader
                class="col-6 ps-0"
                label="CV"
                [accept]="'.pdf'"
                id="CV"
                name="CV"
                [ngModel]="doc"
                (ngModelChange)="uploadCvFile($event)"
                tabindex="9"
                >
              </app-material-chunk-file-uploader>
            </div>

            <div class="form-group row">
              <div class="col-12">
                <app-material-auto-complete
                  placeholder="Credential Document"
                  [formatter]="credentialItemFormatter"
                  name="Credential Document"
                  [(ngModel)]="selectedCredentialDocument"
                  [items]="credentials"
                  >
                </app-material-auto-complete>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-12 text-end">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="changeStatus()"
                  >
                  Change Status&nbsp;&nbsp;
                  <span [ngClass]="getActivationStatus()"></span>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="mt-3" appearance="outlined">
          <mat-card-content class="d-flex justify-content-end gap-2">
            <button
              mat-stroked-button
              color="primary"
              [routerLink]="['/vessels/crew-change/crew/profile/', crew.id]"
              >
              Back to Profile
            </button>
            <button
              mat-stroked-button
              color="primary"
              [disabled]="!Crew.form.valid"
              (click)="save()"
              >
              Save
            </button>
          </mat-card-content>
        </mat-card>
      </div>
      <!--crew exist doc-->
      <div class="col-md-7 col-xs-12 col-sm-12">
        @if (!showRemark && !showDocumentEntry) {
          <mat-card
            appearance="outlined"
            >
            <mat-card-header>
              <mat-card-title class="mb-3">Crew Credentials</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              @if (crew.seamanDetails) {
                <div
                  class="d-flex justify-between align-items-center mb-2"
                  >
                  <mat-icon color="primary" class="me-3">assignment_ind</mat-icon>
                  <span class="col-md-5">
                    {{ getCredentialsLabel(crew.seamanDetails.documentName) }}
                  </span>
                  <div class="text-gray-600 text-sm col-md-5">
                    {{ crew.seamanDetails.number }} •
                    {{ crew.seamanDetails.expirationDate | date : "yyyy/MM/dd" }}
                  </div>
                  <button
                    mat-icon-button
                    class="col-md-4"
                    color="primary"
                    matTooltip="View Seaman Book"
                    (click)="showSeamanBook = [true]"
                    >
                    <mat-icon>attachment</mat-icon>
                  </button>
                  <app-material-pdf-viewer-pop-up
                    (show)="showSeamanBook"
                    [fileId]="crew.seamanDetails.fileId"
                    [title]="'Seaman Book'"
                    >
                  </app-material-pdf-viewer-pop-up>
                </div>
              }
              @if (crew.passportDetails) {
                <div
                  class="d-flex justify-between align-items-center mb-2"
                  >
                  <mat-icon color="primary" class="me-3">flight</mat-icon>
                  <span class="col-md-5">
                    {{ getCredentialsLabel(crew.passportDetails.documentName) }}
                  </span>
                  <div class="text-gray-600 text-sm col-md-5">
                    {{ crew.passportDetails.number }} •
                    {{ crew.passportDetails.expirationDate | date : "yyyy/MM/dd" }}
                  </div>
                  <button
                    mat-icon-button
                    class="col-md-4"
                    color="primary"
                    matTooltip="View Passport"
                    (click)="showPassport = true"
                    >
                    <mat-icon>attachment</mat-icon>
                  </button>
                  <app-material-pdf-viewer-pop-up
                    [(show)]="showPassport"
                    [fileId]="crew.passportDetails.fileId"
                    [title]="'Passport'"
                    >
                  </app-material-pdf-viewer-pop-up>
                </div>
              }
              @if (crew.cvDocumentId) {
                <div
                  class="d-flex justify-between align-items-center mb-2"
                  >
                  <mat-icon color="primary" class="me-3">description</mat-icon>
                  <span class="col-md-10">CV</span>
                  <button
                    mat-icon-button
                    class="col-md-2"
                    color="primary"
                    matTooltip="View CV"
                    (click)="showCV = true"
                    >
                    <mat-icon>attachment</mat-icon>
                  </button>
                  <app-material-pdf-viewer-pop-up
                    [(show)]="showCV"
                    [fileId]="crew.cvDocumentId"
                    [title]="'CV'"
                    >
                  </app-material-pdf-viewer-pop-up>
                </div>
              }
              @for (credential of crew.credentials; track $index; let i = $index) {
                <div
                  class="d-flex justify-between align-items-center mb-2"
                  >
                  <mat-icon color="primary" class="me-3">badge</mat-icon>
                  <span class="col-md-4">
                    {{ getCredentialsLabel(credential.documentName) }}
                  </span>
                  <div class="text-gray-600 text-sm col-md-4">
                    {{ credential?.number }} •
                    {{ credential?.expirationDate | date : "yyyy/MM/dd" }}
                  </div>
                  <button
                    mat-icon-button
                    color="primary"
                    class="col-md-4"
                matTooltip="View {{
                  getCredentialsLabel(credential.documentName)
                }}"
                    (click)="showDocs[i] = true"
                    >
                    <mat-icon>attachment</mat-icon>
                  </button>
                  <app-material-pdf-viewer-pop-up
                    [(show)]="showDocs[i]"
                    [fileId]="credential.fileId"
                    [title]="getCredentialsLabel(credential.documentName) || ''"
                    >
                  </app-material-pdf-viewer-pop-up>
                </div>
              }
            </mat-card-content>
          </mat-card>
        }

        <!--remarks table-->
        @if (crew.remarks && crew.remarks.length > 0 && !showRemark && !showDocumentEntry) {
        <mat-card appearance="outlined" class="mt-3">
          <mat-card-header class="m-2">
            <mat-card-title class="m-2">Remarks</mat-card-title>
          </mat-card-header>
          <mat-card-content class="pd-2">
            <div class="table-responsive">
              <table class="table table-striped table-hover align-middle">
                <thead class="bg-light text-muted text-center">
                  <tr>
                    <th></th>
                    <th>Status</th>
                    <th>Author</th>
                    <th>Comment</th>
                    <th>Date</th>
                    <th>Document</th>
                  </tr>
                </thead>
                  <tbody>
                  @for (remark of crew.remarks; track $index; let i = $index) {
                    <tr>
                    <td *appHideIfNotInRole="['admin-editor']">
                    <a class="btn btn-link" (click)="removeRemark(i)">
                    <i class="fa fa-trash"></i>
                    </a>
                    </td>
                    <td>{{ remark.status }}</td>
                    <td>{{ findCrew(remark.author || '') }}</td>
                    <td>{{ remark.comment }}</td>
                    <td class="text-end">{{ remark.date }}</td>
                    <td class="text-center">
                    @if (remark.docId) {
                    <button
                    mat-icon-button
                    color="primary"
                    matTooltip="View Remark Document"
                    (click)="showRemarkDoc[i] = true"
                    >
                    <mat-icon class="fs-4">open_in_new</mat-icon>
                    </button>
                    }
                    @if (remark.docId) {
                    <app-material-pdf-viewer-pop-up
                    [(show)]="showRemarkDoc[i]"
                    [fileId]="remark.docId"
                    [title]="'Remark document'"
                    >
                    </app-material-pdf-viewer-pop-up>
                    }
                    </td>
                    </tr>
                  }
                  </tbody>
              </table>
            </div>
          </mat-card-content>
        </mat-card>
            }
        @if (crew.oldDetails && crew.oldDetails.docs && crew.oldDetails.docs.length > 0) {
          <mat-card
            class="mb-2"
            appearance="outlined"
            >
            <mat-card-header>Old Passport Details</mat-card-header>
            <mat-card-content>
              <table class="table table-sm table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Document Name</th>
                    <th>Number</th>
                    <th>Issue Date</th>
                    <th>Expiration Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (detail of crew.oldDetails.docs; track $index) {
                    <tr>
                      <td>{{ detail.documentName }}</td>
                      <td>{{ detail.number }}</td>
                      <td>{{ detail.issueDate }}</td>
                      <td>{{ detail.expirationDate }}</td>
                      <td>
                        @if (detail.fileId) {
                          <a
                            (click)="downLoadDocument(detail.fileId)"
                            >
                            <i class="fa fa-download" aria-hidden="true"></i>
                          </a>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </mat-card-content>
          </mat-card>
        }
        <!--popup forms-->

        @if (showDocumentEntry) {
          <mat-card
            class="mb-3 col-md-6"
            appearance="outlined"
            >
            <mat-card-header>
              <mat-card-title>{{ documentEntryTitle }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="form-group row">
                <app-material-pg-input
                  type="text"
                  name="tempNo"
                  [(ngModel)]="tempCredential.number"
                  label="{{ documentEntryTitle }} No"
                  [disabled]="disableEdit()"
                  [required]="true"
                  >
                </app-material-pg-input>
              </div>
              <div class="form-group row">
                <app-material-pg-input
                  type="date"
                  name="tempIssueDate"
                  [(ngModel)]="tempCredential.issueDate"
                  label="{{ documentEntryTitle }} Issue Date"
                  [required]="true"
                  >
                </app-material-pg-input>
              </div>
              <div class="form-group row">
                <app-material-pg-input
                  type="date"
                  name="tempExpireDate"
                  [(ngModel)]="tempCredential.expirationDate"
                  label="{{ documentEntryTitle }} Expiration Date"
                  [required]="true"
                  >
                </app-material-pg-input>
              </div>
              <div class="form-group row">
                <app-material-chunk-file-uploader
                  [accept]="'.pdf'"
                  [ngModel]="tempCredential.fileId"
                  name="tempFileId"
                  label="Upload {{ documentEntryTitle }} Doc"
                  (ngModelChange)="uploadCredentialFile($event)"
                  [disabled]="disableEdit()"
                  >
                </app-material-chunk-file-uploader>
              </div>
              <div class="form-group row">
                <div class="col-12 text-end me-3">
                  <button
                    mat-stroked-button
                    color="warn"
                    class="pull-right ms-2"
                    (click)="showDocumentEntry = false"
                    >
                    Cancel
                  </button>
                  <button
                    mat-stroked-button
                    color="primary"
                    class="pull-right ms-2"
                  [disabled]="
                    !tempCredential.number ||
                    !tempCredential.issueDate ||
                    !tempCredential.expirationDate ||
                    !tempCredential.fileId
                  "
                    (click)="addToCredentials()"
                    >
                    Add to Credentials
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        }

        @if (showRemark) {
          <mat-card class="mt-6 col-6" appearance="outlined">
            <mat-card-header class="mb-3">
              <mat-card-title>Remark</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="mb-6 d-flex align-items-center">
                <mat-label class="me-5 text-sm font-semibold mb-0">
                  Status
                </mat-label>
                <div>
                  <mat-radio-group
                    [(ngModel)]="tempRemark.status"
                    name="status"
                    required
                    >
                    <mat-radio-button value="active" class="me-5"
                      >Active</mat-radio-button
                      >
                      <mat-radio-button value="conditional" class="me-5"
                        >Conditional</mat-radio-button
                        >
                        <mat-radio-button value="blacklisted"
                          >Black listed</mat-radio-button
                          >
                        </mat-radio-group>
                      </div>
                    </div>
                    <div class="form-group row">
                      <app-material-pg-input
                        type="text"
                        name="remarkComment"
                        [(ngModel)]="tempRemark.comment"
                        label="Comment"
                        [disabled]="disableEdit()"
                        [required] = "true"
                        >
                      </app-material-pg-input>
                    </div>
                    <div class="form-group row">
                      <app-material-auto-complete
                        [formatter]="crewFormatter"
                        name="author"
                        [placeholder]="'Author'"
                        [(ngModel)]="author"
                        [items]="authors"
                        >
                      </app-material-auto-complete>
                    </div>
                    <div class="form-group row">
                      <app-material-pg-input
                        type="date"
                        name="remarkDate"
                        [(ngModel)]="tempRemark.date"
                        label="Date"
                        [required]="true"
                        >
                      </app-material-pg-input>
                    </div>
                    <div class="mt-4">
                      <app-material-chunk-file-uploader
                        [accept]="'.pdf'"
                        name="remarkFileId"
                        [ngModel]="doc2"
                        (ngModelChange)="uploadRemarkFile($event)"
                        [disabled]="disableEdit()"
                        >
                      </app-material-chunk-file-uploader>
                    </div>
                    <div class="form-group row">
                      <div class="col-12 text-end me-3">
                        <button
                          mat-stroked-button
                          color="warn"
                          class="pull-right ms-2"
                          (click)="showRemark = false"
                          >
                          Cancel
                        </button>
                        <button
                          mat-stroked-button
                          color="primary"
                          class="pull-right ms-2"
                          (click)="addToRemarks()"
                          [disabled]="!Crew.form.valid"
                          >
                          Add
                        </button>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </form>
        </fieldset>
      </div>
